import React from "react";

import { connect } from "react-redux";

import Stack from "@busbud/design-system-components/dist/Stack";
import Text from "@busbud/design-system-components/dist/Text";

import { useAppContext } from "@app/helpers/hooks";
import type { ResultsReduxState } from "@app/types/results-redux-types";
import type { SearchInfo } from "@app/types/search-types";

import { useStyles } from "./cart-creation.styles";
import { isReturn, isRoundtrip } from "../../../helpers/search";
import { AlertDialog } from "../../alert-dialog";
import { LinearProgressBar } from "../../linear-progress-bar";
import { BusAgnosticIllustration } from "../illustrations/busAgnostic";

interface OwnProps {}

interface ReduxProps {
  search: SearchInfo;
}

const CartCreation: React.FC<OwnProps & ReduxProps> = ({ search }) => {
  const { translator } = useAppContext();
  const { classes } = useStyles();
  const is_roundtrip = isRoundtrip(search);
  const is_return = isReturn(search);

  const title =
    !is_roundtrip || is_return
      ? translator.t("!results.cart-creation.title")
      : translator.t("!results.cart-creation.title.roundtrip-outbound");

  const content =
    !is_roundtrip || is_return
      ? translator.t("!results.cart-creation.message")
      : translator.t("!results.cart-creation.message.roundtrip-outbound");

  const message = (
    <Stack direction="column" alignItems="center" spacing={1}>
      <div>
        <BusAgnosticIllustration />
      </div>
      <Text size="lg" align="center">
        {title}
      </Text>
      <Text size="md" align="center">
        {content}
      </Text>
      <LinearProgressBar className={classes.gutter} quick_start />
    </Stack>
  );

  return <AlertDialog title={false} message={message} />;
};

const mapStateToProps = (state: ResultsReduxState): any => {
  return {
    search: state.search
  };
};

const CartCreationComponent = connect<
  ReduxProps,
  {},
  OwnProps,
  ResultsReduxState
>(mapStateToProps)(CartCreation);

export { CartCreationComponent as CartCreation };
